import React from "react";
import { SupChip, SupText } from "@repo/core-ui";

import { SupTxChain } from "../../TxChain";
import type { ReceivedTokenProps } from "../../types";

export function ReceivedTokenValue({ amount, symbol, url, img, chainName, chainLogo, chainUrl }: ReceivedTokenProps) {
  const token = img ? <SupChip icon={img} label={symbol} border borderStyle="solid" type="rounded" /> : symbol;
  const clickableToken = url ? (
    <a href={url} target="_blank" rel="noreferrer">
      {token}
    </a>
  ) : (
    token
  );

  return (
    <SupText as="div" variant="subtitle1" className="flex items-center gap-2 whitespace-nowrap">
      <span>{amount}</span> {clickableToken} ON
      <SupTxChain chainLogo={chainLogo} chainName={chainName} explorerUrl={chainUrl} />
    </SupText>
  );
}
